import script from "./ActiveXmairComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ActiveXmairComponent.vue?vue&type=script&setup=true&lang=js"

import "./ActiveXmairComponent.vue?vue&type=style&index=0&id=7774b9b8&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7774b9b8"]])

export default __exports__